import React from 'react';
import eu from '../../Assets/eu.png';
import facebook from '../../Assets/facebook.svg';
import linkin from '../../Assets/linkin.svg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div>
        <p className="footer-text">Erasmus+ 2023-1-SK01-KA220-ADU-000160921</p>
        <p className="footer-text">
          Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or the European Education and Culture Executive Agency (EACEA). Neither the European Union nor EACEA can be held responsible for them.
        </p>
      </div>
      <div className="spacer">
      </div>
      <div className="social-icons">
        <div className="social-icon">
          <a href="https://www.facebook.com/profile.php?id=61559349077251" target="_blank" rel="noopener noreferrer">
          <img src={facebook} alt="Facebook Icon" className="icon" />
          </a>
          <a href="https://www.linkedin.com/company/green-transitions-erasmus-project/about/" target="_blank" rel="noopener noreferrer">
          <img src={linkin} alt="LinkedIn Icon" className="icon" />
          </a>
        </div>
      </div>
      <div className="contact">
        <p className="contact-text">Contact us: <a href="mailto:transitionsgreen@gmail.com">transitionsgreen@gmail.com</a></p>
      </div>
      <div className="eu-logo">
        <img src={eu} alt="EU Logo" className="logo" />
      </div>
    </footer>
  );
};

export default Footer;
